export default {
  title: "больше об Oracle".toUpperCase(),
}
